import type { SuspenseProps } from "react";
import { Suspense, useSyncExternalStore } from "react";
import {
  getLoadedComponents,
  subscribeToLoadedComponents,
} from "@/utils/lazy-with-retry";

// React holds a boundary's retry until 300 ms after the last fallback it showed, however soon the code arrives, and a
// page's queries only start when it commits. A page behind two lazy steps lost about 450 ms to this on every load, on
// the way to pages whose fallback is an empty spinner that fades in after 250 ms. A normal update isn't held: when code
// arrives, this renders the boundary again and it commits right away.
export function RouteSuspense(props: SuspenseProps) {
  useSyncExternalStore(subscribeToLoadedComponents, getLoadedComponents);
  return <Suspense {...props} />;
}
